import { toggleClass } from 'utils/toggle-classlist'
import piwikService from 'services/piwik'

declare global {
  interface Window {
    __lc: any
    ___gcfg: any
    LiveChatWidget: any
  }
}

const $floaterBox = document.querySelector<HTMLElement>('[data-js-selector="floater-box"]')
const $floaterButton = document.querySelector<HTMLButtonElement>('[data-js-selector="floater-button"]')
const $floaterContent = document.querySelector<HTMLElement>('[data-js-selector="floater-box-content"]')
const $livechatButtons = document.querySelectorAll<HTMLButtonElement>('[data-js-selector="livechat-button"]')
const liveChatStatus = sessionStorage.getItem('livechat_opened')

function initLivechatParams(): void {
  window.__lc = window.__lc || {}
  window.__lc.license = 1085871
  window.__lc.asyncInit = true
  ;(function (n, t, c) {
    function i(n) {
      return e._h ? e._h.apply(null, n) : e._q.push(n)
    }
    const e = {
      _q: [],
      _h: null,
      _v: '4.0',
      on(...args) {
        i(['on', c.call(args)])
      },
      call(...args) {
        i(['call', c.call(args)])
      },
      init() {
        const n = t.createElement('script')
        ;(n.async = !0),
          (n.type = 'text/javascript'),
          (n.src = 'https://cdn.livechatinc.com/tracking.js'),
          n.setAttribute('data-livechat', ''),
          t.head.appendChild(n)
      },
    }
    !n.__lc.asyncInit && e.init(), (n.LiveChatWidget = n.LiveChatWidget || e)
  })(window, document, [].slice)
}

function setEscKeyHandler(): void {
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' || event.key === 'Esc') {
      if (!$floaterContent.hidden) {
        $floaterContent.hidden = false
        $floaterButton?.setAttribute('aria-expanded', 'false')
        $floaterBox?.classList.remove('is-open')
        $floaterButton?.focus()
      }
    }
  })
}

function toggleFloater(): void {
  const isExpanded = $floaterButton?.getAttribute('aria-expanded') === 'true'

  if ($floaterContent) {
    // setTimeout is used to allow the CSS transition to complete before hiding the content
    isExpanded ? setTimeout(() => ($floaterContent.hidden = isExpanded), 400) : ($floaterContent.hidden = isExpanded)
  }

  $floaterButton?.setAttribute('aria-expanded', isExpanded ? 'false' : 'true')
  toggleClass($floaterBox, 'is-open')

  if (isExpanded) {
    piwikService.pushPiwikNotification(['FastContact', 'Open', 'Frontpage'])
  }
}

function onVisibilityChanged(data: { visibility: string }): void {
  switch (data.visibility) {
    case 'maximized':
      sessionStorage.setItem('livechat_opened', 'true')
      break
    case 'hidden':
      sessionStorage.removeItem('livechat_opened')
      break
  }
}

const isLivechatParamsInited = (): boolean => !!document.querySelector<HTMLScriptElement>('[data-livechat]')

function initLivechat(): void {
  if (!isLivechatParamsInited()) {
    initLivechatParams()
    window.LiveChatWidget.init()
  }

  window.LiveChatWidget.call('maximize')
  window.LiveChatWidget.on('visibility_changed', onVisibilityChanged)
  sessionStorage.setItem('livechat_opened', 'true')
}

export function initFastContact(): void {
  if (liveChatStatus) initLivechat()

  $floaterButton?.addEventListener('click', toggleFloater)
  setEscKeyHandler()

  $livechatButtons?.forEach(($button) => {
    $button.addEventListener('click', initLivechat)
  })

  if (location.search.includes('chat')) {
    initLivechat()
  }
}
